jQuery( document ).on( 'page.ready', function () {
	$ = jQuery;

	if ( $( 'main.science-page' ).length ) {

		$( '.references button' ).click( function ( e ) {

			var $refs = $( this ).siblings( '.container' );

			$refs.slideToggle( 1250 ).toggleClass( 'is-open' );

		} );

		var smcontroller = new ScrollMagic.Controller();
		// Reset SMController for new page
		smcontroller.destroy( true );
		smcontroller = new ScrollMagic.Controller();

		$( '#part1' ).each( function () {
			var me = $( this );
			var sci1 = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: 0.5
				} )
				.on( 'start', function ( event ) {
					$( '.science-nav .chapter-2' ).removeClass( 'active' );
					$( '.science-nav .chapter-2' ).addClass( 'notactive' );
					$( '.science-nav .chapter-1' ).removeClass( 'notactive' );
					$( '.science-nav .chapter-1' ).addClass( 'active' );
				} )
				.addTo( smcontroller );
		} );
		$( '.chapterone' ).each( function () {
			var me = $( this );
			var sci1 = new ScrollMagic.Scene( {
					triggerElement: this,
					offset: me.height(),
					triggerHook: 0.5
				} )
				.on( 'start', function ( event ) {
					$( '.science-nav .chapter-2' ).removeClass( 'active' );
					$( '.science-nav .chapter-2' ).addClass( 'notactive' );
					$( '.science-nav .chapter-1' ).removeClass( 'notactive' );
					$( '.science-nav .chapter-1' ).addClass( 'active' );
				} )
				.addTo( smcontroller );
		} );

		$( '#part2' ).each( function () {
			var me = $( this );
			var sci2 = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: 0.5
				} )
				.on( 'start', function ( event ) {
					$( '.science-nav .chapter-1' ).removeClass( 'active' );
					$( '.science-nav .chapter-1' ).addClass( 'notactive' );
					$( '.science-nav .chapter-2' ).removeClass( 'notactive' );
					$( '.science-nav .chapter-2' ).addClass( 'active' );
				} )
				.addTo( smcontroller );
		} );

		$( 'a[href="#reflink"]' ).click( function ( event ) {
			var findSection = $( this ).closest( 'section' ),
				findRefSection = $( findSection ).siblings( '.references' ),
				openBtn = $( findRefSection ).children( 'button' );

			$( 'html,body' ).animate( { scrollTop: $( findRefSection ).offset().top - ( $( '#nav-bar' ).height() ) }, 800, 'swing' );
			setTimeout( function () {
				$( openBtn ).trigger( 'click' );
			}, 650 );
		} );

	} //end page check
} );